<div>
  {{ label$ | async }}
  <mat-icon *ngIf="help$ | async as help" class="help-icon" [matTooltip]="help"
    >help_outline</mat-icon
  >
</div>
